import { School } from '../types/schools';

export const getCurrentSchoolYear = (schools?: School[]) => {
  if (!schools || !schools[0]) return '';

  const fullYear = schools[0].years[0].year;

  return fullYear.substring(2);
};

export default getCurrentSchoolYear;
